import { createAction, createAsyncAction } from 'typesafe-actions';

import { SurveyResource, SurveyResponse } from '@portal/common/types';

export const getSurveysAsync = createAsyncAction(
    'GET_SURVEYS_REQUEST',
    'GET_SURVEYS_SUCCESS',
    'GET_SURVEYS_FAILURE'
)<null, SurveyResource[], string>();

export const voteSurvey = createAction('SURVEY_VOTED')<SurveyResponse>();
